module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-log-trm/master-log-trm.component.scss
// module id = ./src/app/master/master-log-trm/master-log-trm.component.scss
// module chunks = main